import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useRetailerFinancial } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailerFinancial";
import { NetTermsCard } from "@faire/retailer-visitor-shared/views/SignUp/_components/net-terms/NetTermsCard";
import { moneyOrZero, RoundingStrategy } from "@faire/web--source/common/money";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Money } from "@faire/web--source/ui/Money";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import React from "react";

interface IProps {
  overrideNetTermsAmount?: IFaireMoney;
}

export const CoreCard: React.FC<IProps> = ({ overrideNetTermsAmount }) => {
  const { currency: displayCurrency } = useRetailerFinancial();
  const { retailer } = useRetailer();

  return (
    <NetTermsCard>
      <Typography variant="paragraphSansMedium">{retailer?.name}</Typography>
      <Spacer height="5x" />
      <Typography variant="displayLSerifRegular">
        <Money
          money={moneyOrZero(
            overrideNetTermsAmount ?? retailer?.terms_limit,
            displayCurrency
          )}
          roundingStrategy={RoundingStrategy.DROP_CENTS}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography variant="labelSansRegular">
        <StrictLocalMsg
          defaultMessage="Your available payment terms"
          description={{
            text: "Subtitle for the net terms card",
            img: "https://cdn.faire.com/fastly/ee58f6a470130806b26663ed1eaff1a92135ec4c6f5f4a425e46f4af13bd0206.png",
          }}
        />
      </Typography>
    </NetTermsCard>
  );
};
